import axios from 'axios'

const API_URL = 'https://app.motoboutique.mx'

const plainAxiosInstance = axios.create({
    baseURL: API_URL,
    withCredentials: false,
    headers: {
        'Accept': 'application/json',
        'Content-type': 'application/json',
        'Authorization': 'm4H0N0wm4YuYuk1m1K1n4m1D0r1k0'
    }
})

const plainAxiosInstanceAuth = axios.create({
    baseURL: API_URL,
    withCredentials: false,
    headers: {
        'Content-Type': 'application/json',
    }
})

const formAxiosInstance = axios.create({
    baseURL: API_URL,
    withCredentials: false,
    headers: {
        'Content-Type': "multipart/form-data",
    }
})

export { plainAxiosInstance, formAxiosInstance, plainAxiosInstanceAuth }